import { useEffect } from "react";

import { useCheckUser } from "@/api/user/check-user";
import DashboardContainer from "@/components/dashboard/dashboard-container";
import FirstSetup from "@/components/dashboard/first-setup/first-setup";
import useGlobalLoading from "@/store/global-loading";
import useOnboardingData from "@/store/onboarding-data";
import { Navigate } from "react-router";

const Home = () => {
    const { data, isLoading: checkUserLoading, isSuccess: checkUserSuccess } = useCheckUser();

    const { isInitialized, isStep3Complete, userData } = useOnboardingData();

    const { setIsLoading } = useGlobalLoading();

    useEffect(() => {
        setIsLoading(true);

        if (!checkUserLoading) {
            setIsLoading(false);
        }

        return () => setIsLoading(false);
    }, [setIsLoading, checkUserLoading]);

    if (data && !checkUserLoading && checkUserSuccess && !isStep3Complete && !data?.data?.user?.is_paid && userData?.role !== "member") {
        return <Navigate to="/onboarding/step-1" replace />;
    }

    if (!isInitialized) {
        return <FirstSetup />;
    }

    return (
        <div>
            <DashboardContainer />
        </div>
    );
};

export default Home;
